import { render, staticRenderFns } from "./feeCompany.vue?vue&type=template&id=cbade034&scoped=true"
import script from "./feeCompany.vue?vue&type=script&lang=js"
export * from "./feeCompany.vue?vue&type=script&lang=js"
import style0 from "./feeCompany.vue?vue&type=style&index=0&id=cbade034&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbade034",
  null
  
)

export default component.exports